import { trackAction } from 'helpers/trackingOM';

export class BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    getCleanTitle() {
        return this.element.querySelector('h2.video-section-title')?.textContent?.trim();
    }
    getPosRowNum() {
        const carousel = this.element.closest('.js-le-carousel');
        return carousel.getAttribute('data-position');
    }
    trackAction(eventString = '', trackingObj = {}) {
        trackAction(eventString, trackingObj);
    }
}
